import { useReducer } from "react";
import { defaultTo, cond, propEq, always, get, stubTrue } from "lodash/fp";
const DECREMENT = "use-number/DECREMENT";
const FLUSH = "use-number/FLUSH";
const INCREMENT = "use-number/INCREMENT";
const RESET_VALUE = "use-number/RESET_VALUE";
const SET_VALUE = "use-number/SET_VALUE";
function numberReducer(state, action) {
  const { dirty, max, min, step, value } = state;
  const numberValue = Number(value);
  const newValue = cond([
    [
      propEq("type", DECREMENT),
      always(String(Math.max(min, numberValue - step)))
    ],
    [
      propEq("type", INCREMENT),
      always(String(Math.min(max, numberValue + step)))
    ],
    [propEq("type", RESET_VALUE), get("value")],
    [propEq("type", SET_VALUE), get("value")],
    [stubTrue, always(value)]
  ])(action);
  return {
    ...state,
    dirty: action.type !== FLUSH && action.type !== RESET_VALUE && (dirty || value !== newValue),
    value: newValue
  };
}
function decrement() {
  return {
    type: DECREMENT
  };
}
function flush() {
  return {
    type: FLUSH
  };
}
function increment() {
  return {
    type: INCREMENT
  };
}
function resetValue(value) {
  return {
    type: RESET_VALUE,
    value
  };
}
function setValue(value) {
  return {
    type: SET_VALUE,
    value
  };
}
function useNumber(options = {}) {
  return useReducer(numberReducer, {
    dirty: false,
    max: defaultTo(Infinity, options.max),
    min: defaultTo(-Infinity, options.min),
    step: defaultTo(0, options.step),
    value: String(defaultTo(0, options.value))
  });
}
export {
  decrement,
  flush,
  increment,
  resetValue,
  setValue,
  useNumber
};
